import { PlanRestrictionsProps } from '../../types/components/pricing/PlanRestrictions';

import { DashIcon } from '../../modules/Icons';

const PlanRestrictions: React.FC<PlanRestrictionsProps> = ({
  restrictions,
}) => {
  if (!restrictions) return <></>;
  return (
    <div className="flex flex-col justify-end flex-1" cy-test-id="plan-restrictions">
      <span className="text-[14px] font-semibold leading-24 text-a-gray mb-1" cy-test-id="title">
        Restrictions:
      </span>
      <div className="flex flex-col">
        {restrictions.split('\n').map((restriction, index) => (
          <div key={index} cy-test-id={`restriction-${index}`} className="flex items-center">
            <DashIcon className="mr-2" />
            <span className="text-a-gray w-full text-[12px] 2xl:text-[14px] leading-[24px] xl:leading-none 2xl:leading-[24px]">
              {restriction.trim()}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default PlanRestrictions;
